import { addDays, fmtDate, money, today } from '../dates.js';
import { myName } from '../team/team.js';
import { t } from '../i18n/index.js';
import { fillTpl, payDetails, tpl, waLink } from '../messaging.js';
import { eventsIn, stu } from '../model.js';
import { S, persist } from '../state.js';
import { IC, closeSheet, esc, sheet, toast } from '../ui.js';
import { recapVars } from './recap.js';

export function openMessenger(stuId,preset){
  const s=stu(stuId);if(!s)return;
  let type=preset||'reminder';
  let lang=s.contactLang||S.settings.lang;
  const upcoming=()=>eventsIn(today(),addDays(today(),60)).filter(e=>e.studentId===s.id&&e.status==='planned').slice(0,6);
  const doneList=()=>S.sessions.filter(x=>x.studentId===s.id&&x.status==='done').sort((a,b)=>(b.date+b.time).localeCompare(a.date+a.time)).slice(0,8);
  const invList=()=>S.invoices.filter(i=>i.studentId===s.id).sort((a,b)=>b.issue.localeCompare(a.issue)).slice(0,8);
  const b=sheet(`<div class="sheethead"><h2>${t('msg.title',{name:esc(s.first)})}</h2><button class="iconbtn" data-a="x">${IC.x}</button></div>
  <div class="sheetbody">
    <div class="formrow">
      <div class="field"><label>${t('msg.type')}</label><select class="select" id="mg-type">
        ${['reminder','summary','invoice','reschedule','custom'].map(x=>'<option value="'+x+'"'+(x===type?' selected':'')+'>'+(x==='custom'?t('msg.t.custom'):t('set.tpl.'+x))+'</option>').join('')}
      </select></div>
      <div class="field"><label>${t('set.tplLang')}</label><select class="select" id="mg-lang">${['en','de','fr'].map(l=>'<option value="'+l+'"'+(l===lang?' selected':'')+'>'+({en:'English',de:'Deutsch',fr:'Français'}[l])+'</option>').join('')}</select></div>
    </div>
    <div id="mg-extra"></div>
    <div class="divider"></div>
    <div class="row between mb8"><span class="eyebrow">${t('msg.preview')}</span><button class="btn small ghost" data-a="refill">↻ ${t('msg.refill')}</button></div>
    <div class="field"><label>${t('set.subject')}</label><input class="input" id="mg-s"></div>
    <div class="field"><label>${t('set.body')}</label><textarea class="textarea" id="mg-b" style="min-height:190px"></textarea></div>
    <p class="hint">${t('msg.exact')}</p>
    <details id="mg-tpld" class="mt"><summary style="cursor:pointer;font-weight:650;font-size:13px;color:var(--ink2)">✎ ${t('msg.editTpl')}</summary>
      <div class="field mt"><label>${t('set.subject')}</label><input class="input" id="mg-ts"></div>
      <div class="field"><label>${t('set.body')}</label><textarea class="textarea" id="mg-tb" style="min-height:150px;font-size:13px"></textarea></div>
      <p class="hint">${esc(t('set.phList'))}</p>
      <div class="row mt"><button class="btn small primary" data-a="tplsave">${t('c.save')}</button><button class="btn small" data-a="tplreset">${t('set.tplReset')}</button></div>
    </details>
  </div>
  <div class="sheetfoot">
    <div class="left"><button class="btn" data-a="copy">${IC.copy} ${t('c.copy')}</button></div>
    ${s.email?'<button class="btn" data-a="mail">'+IC.mail+' '+t('stu.mail')+'</button>':''}
    ${s.phone?'<button class="btn primary" data-a="wa">'+IC.wa+' '+t('stu.wa')+'</button>':(s.email?'':'<button class="btn primary" data-a="copy2">'+IC.copy+' '+t('c.copy')+'</button>')}
  </div>`,'wide');
  const q=x=>b.querySelector(x);
  const pickSes=()=>{const el=q('#mg-pick');const list=type==='summary'?doneList():upcoming();return list.find(x=>x.id===(el&&el.value))||list[0]||null};
  const pickInv=()=>{const el=q('#mg-pick');const list=invList();return list.find(x=>x.id===(el&&el.value))||list[0]||null};
  const drawExtra=()=>{
    const ex=q('#mg-extra');
    if(type==='reminder'||type==='reschedule'){
      const list=upcoming();
      ex.innerHTML=list.length?'<div class="field"><label>'+t('msg.pick')+'</label><select class="select" id="mg-pick">'+list.map(x=>'<option value="'+x.id+'">'+fmtDate(x.date)+' · '+x.time+'</option>').join('')+'</select></div>'
        +(type==='reschedule'?'<div class="formrow"><div class="field"><label>'+t('msg.nd')+'</label><input class="input" type="date" id="mg-nd" value="'+(list[0]?list[0].date:today())+'"></div><div class="field"><label>'+t('msg.nt')+'</label><input class="input" type="time" id="mg-nt" value="'+(list[0]?list[0].time:'17:00')+'"></div></div>':'')
        :'<p class="hint mb8">'+t('msg.none')+'</p>';
    }else if(type==='summary'){
      const list=doneList();
      ex.innerHTML=list.length?'<div class="field"><label>'+t('msg.pick')+'</label><select class="select" id="mg-pick">'+list.map(x=>'<option value="'+x.id+'">'+fmtDate(x.date)+(x.summary?' · '+t('ses.recap')+' ✓':'')+'</option>').join('')+'</select></div>':'<p class="hint mb8">'+t('msg.none')+'</p>';
    }else if(type==='invoice'){
      const list=invList();
      ex.innerHTML=list.length?'<div class="field"><label>'+t('msg.pickInv')+'</label><select class="select" id="mg-pick">'+list.map(i=>'<option value="'+i.id+'">'+esc(i.no)+' · '+money(i.total)+'</option>').join('')+'</select></div>':'<p class="hint mb8">'+t('msg.none')+'</p>';
    }else ex.innerHTML='';
    ex.querySelectorAll('select,input').forEach(el=>el.onchange=fill);
  };
  const fill=()=>{
    const base={student:s.first,teacher:myName()||'—',paydetails:payDetails()||'—'};
    let vars=base,tp={s:'',b:''};
    if(type==='reminder'){const ses=pickSes();tp=tpl('reminder',lang);
      vars={...base,date:ses?fmtDate(ses.date):'—',time:ses?ses.time:'—',duration:ses?ses.dur:'—',link:(ses&&ses.meet)||s.meet||'—'};}
    else if(type==='summary'){const ses=pickSes();tp=tpl('summary',lang);
      vars=ses?{...base,...recapVars(ses,ses.summary||{topics:[],vocab:[],grammar:'',homework:'',next:'',note:''})}:base;}
    else if(type==='invoice'){const inv=pickInv();tp=tpl('invoice',lang);
      vars={...base,invoiceNo:inv?inv.no:'—',period:inv?inv.period:'—',amount:inv?money(inv.total):'—',dueDate:inv?fmtDate(inv.due):'—'};}
    else if(type==='reschedule'){const ses=pickSes();tp=tpl('reschedule',lang);
      const nd=q('#mg-nd')?q('#mg-nd').value:today(),nt=q('#mg-nt')?q('#mg-nt').value:'17:00';
      vars={...base,oldTime:ses?fmtDate(ses.date)+' '+ses.time:'—',newTime:fmtDate(nd)+' '+nt};}
    q('#mg-s').value=fillTpl(tp.s,vars);
    q('#mg-b').value=fillTpl(tp.b,vars);
  };
  const msg=()=>({s:q('#mg-s').value.trim(),b:q('#mg-b').value});
  const drawTplEd=()=>{
    const d=q('#mg-tpld');
    if(type==='custom'){d.style.display='none';return}
    d.style.display='';
    const tp=tpl(type,lang);
    q('#mg-ts').value=tp.s;q('#mg-tb').value=tp.b;
  };
  q('[data-a=tplsave]').onclick=()=>{
    if(type==='custom')return;
    S.templates[lang]=S.templates[lang]||{};
    S.templates[lang][type]={s:q('#mg-ts').value,b:q('#mg-tb').value};
    persist();fill();toast(t('c.saved'));
  };
  q('[data-a=tplreset]').onclick=()=>{
    if(type==='custom')return;
    if(S.templates[lang])delete S.templates[lang][type];
    persist();drawTplEd();fill();toast(t('c.saved'));
  };
  const full=()=>{const m=msg();return m.s?m.s+'\n\n'+m.b:m.b};
  const doCopy=()=>{const ta=document.createElement('textarea');ta.value=full();document.body.appendChild(ta);ta.select();
    try{if(navigator.clipboard&&navigator.clipboard.writeText)navigator.clipboard.writeText(full());else document.execCommand('copy')}catch(e){}
    ta.remove();toast(t('c.copied'))};
  q('#mg-type').onchange=e=>{type=e.target.value;drawExtra();drawTplEd();fill()};
  q('#mg-lang').onchange=e=>{lang=e.target.value;drawTplEd();fill()};
  q('[data-a=refill]').onclick=()=>{drawExtra();fill()};
  q('[data-a=x]').onclick=()=>closeSheet(b);
  q('[data-a=copy]').onclick=doCopy;
  if(q('[data-a=copy2]'))q('[data-a=copy2]').onclick=doCopy;
  if(q('[data-a=mail]'))q('[data-a=mail]').onclick=()=>{const m=msg();location.href='mailto:'+encodeURIComponent(s.email)+'?subject='+encodeURIComponent(m.s)+'&body='+encodeURIComponent(m.b)};
  if(q('[data-a=wa]'))q('[data-a=wa]').onclick=()=>window.open(waLink(s.phone,full()),'_blank');
  drawExtra();drawTplEd();fill();
}

/* ================= STUDENTS ================= */
